import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./TestHeader.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";

import { trackPageVisit } from "../competency/PageTracker";


function TestHeader() {

        useEffect(() => {
  
    trackPageVisit("TestHeader");
  
  }, []);


const { wellSignals, valves, toggleValve, setTransmitters } = useContext(WellContext);

const isXV10601Open = !valves.XV_10601;

const FIC_106011 = isXV10601Open
  ? (wellSignals?.NK1?.fic || 0)
  : 0;

  const isXV10602Open = !valves.XV_10602;

const FIC_106012 = isXV10602Open
  ? (wellSignals?.NK2?.fic || 0)
  : 0;

   const isXV10603Open = !valves.XV_10603;

const FIC_106013 = isXV10603Open
  ? (wellSignals?.NK3?.fic || 0)
  : 0;

  /* ================= TOTAL FLOW ================= */
const FIC_10601 =
  FIC_106011 +
  FIC_106012 +
  FIC_106013;


  
const isXV10104Open = !valves.XV_10104;
const PT_106011 = isXV10601Open && isXV10104Open
  ? (wellSignals?.NK1?.pt || 0)
  : 0;

const isXV10204Open = !valves.XV_10204;
const PT_106012 = isXV10602Open && isXV10204Open
  ? (wellSignals?.NK2?.pt || 0)
  : 0;

const isXV10304Open = !valves.XV_10304;
const PT_106013 = isXV10603Open && isXV10304Open
  ? (wellSignals?.NK3?.pt || 0)
  : 0;

  /* ================= TOTAL PRESSURE ================= */
const activePressures = [
  PT_106011,
  PT_106012,
  PT_106013
].filter(p => p > 0); // ignore closed valves (0 values)

const PT_10601 =
  activePressures.length > 0
    ? activePressures.reduce((a, b) => a + b, 0) / activePressures.length
    : 0;



const TT_106011 = isXV10601Open && isXV10104Open
  ? (wellSignals?.NK1?.tt || 0)
  : 0;

const TT_106012 = isXV10602Open && isXV10204Open
  ? (wellSignals?.NK2?.tt || 0)
  : 0;

const TT_106013 = isXV10603Open && isXV10304Open
  ? (wellSignals?.NK3?.tt || 0)
  : 0;

  /* ================= TOTAL PRESSURE ================= */
const activeTemperature = [
  TT_106011,
  TT_106012,
  TT_106013
].filter(p => p > 0); // ignore closed valves (0 values)

const TT_10601 =
  activeTemperature.length > 0
    ? activeTemperature.reduce((a, b) => a + b, 0) / activeTemperature.length
    : 0;





const isXV10604Open = !valves.XV_10604;

const MPFT_106011 =
  isXV10601Open && isXV10104Open && isXV10604Open
    ? (
        (wellSignals?.NK1?.oil || 0) 
      )
    : 0;

const MPFT_106012 =
  isXV10602Open && isXV10204Open && isXV10604Open
    ? (
        (wellSignals?.NK2?.oil || 0)
      )
    : 0;

const MPFT_106013 =
  isXV10603Open && isXV10304Open && isXV10604Open
    ? (
        (wellSignals?.NK3?.oil || 0)
      )
    : 0;

  const MPFT_10601 = MPFT_106011 +  MPFT_106012 +  MPFT_106013;



  const MPFT_106021 =
  isXV10601Open && isXV10104Open && isXV10604Open
    ? (
        (wellSignals?.NK1?.gas || 0) 
      )
    : 0;

const MPFT_106022 =
  isXV10602Open && isXV10204Open && isXV10604Open
    ? (
        (wellSignals?.NK2?.gas || 0)
      )
    : 0;

const MPFT_106023 =
  isXV10603Open && isXV10304Open && isXV10604Open
    ? (
        (wellSignals?.NK3?.gas || 0)
      )
    : 0;

  const MPFT_10602 = MPFT_106021 +  MPFT_106022 +  MPFT_106023;





  const MPFT_106031 =
  isXV10601Open && isXV10104Open && isXV10604Open
    ? (
        (wellSignals?.NK1?.water || 0) 
      )
    : 0;

const MPFT_106032 =
  isXV10602Open && isXV10204Open && isXV10604Open
    ? (
        (wellSignals?.NK2?.water || 0)
      )
    : 0;

const MPFT_106033 =
  isXV10603Open && isXV10304Open && isXV10604Open
    ? (
        (wellSignals?.NK3?.water || 0)
      )
    : 0;

  const MPFT_10603 = MPFT_106031 +  MPFT_106032 +  MPFT_106033;





const [fic10605, setFic10605] = useState(0);

const isXV10605Open = !valves.XV_10605;

useEffect(() => {
  const target = isXV10605Open ? 45.432 : 0;

  const interval = setInterval(() => {
    setFic10605(prev => {
      const diff = target - prev;

      // smooth approach
      let next = prev + diff * 0.1;

      // snap when very close
      if (Math.abs(diff) < 0.01) {
        next = target;
      }

      return next;
    });
  }, 200);

  return () => clearInterval(interval);
}, [isXV10605Open]);



useEffect(() => {
  if (!setTransmitters) return;

  setTransmitters(prev => ({
    ...prev,
    MPFT_10601,
    MPFT_10602,
    MPFT_10603,
    PT_10601,   // 🔥 ADD THIS
    TT_10601,    // optional but recommended
    FIC_10601
  }));
}, [
  MPFT_10601,
  MPFT_10602,
  MPFT_10603,
  PT_10601,
  TT_10601,
  setTransmitters,
  FIC_10601
]);



  return (
    <div className="TestHeader-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "254px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "3.5px 240px"
      }}>
        TEST HEADER MANIFOLD
      </h2>



    {/* =================SHUTDOWN VALVES ================= */}


      {/* XV-10601 */}
      <Valve
        className="XV-10601"
        tag="XV_10601"
        x={143}
        y={85}
        isClosed={valves.XV_10601}
        toggle={toggleValve}
      />

      {/* XV-10602 */}
      <Valve
        className="XV-10602"
        tag="XV_10602"
        x={197}
        y={151}
        isClosed={valves.XV_10602}
        toggle={toggleValve}
      />

        {/* XV-10603 */}
      <Valve
        className="XV-10603"
        tag="XV_10603"
        x={120}
        y={223}
        isClosed={valves.XV_10603}
        toggle={toggleValve}
      />

        {/* XV-10604 */}
      <Valve
        className="XV-10604"
        tag="XV_10604"
        x={990}
        y={180}
        isClosed={valves.XV_10604}
        toggle={toggleValve}
      />

      {/* XV-10605 */}
      <Valve
        className="XV-10605"
        tag="XV_10605"
        x={780}
        y={443}
        isClosed={valves.XV_10605}
        toggle={toggleValve}
      />

        {/* XV-10606 */}
      <Valve
        className="XV-10606"
        tag="XV_10606"
        x={663}
        y={143}
        isClosed={valves.XV_10606}
        toggle={toggleValve}
      />

      <Transmitter4
          value={FIC_106011} x={120} y={112} c="transparent"
        />

        <Transmitter4
          value={FIC_106012} x={120} y={162} c="transparent"
        />

        <Transmitter4
          value={FIC_106013} x={120} y={182} c="transparent"
        />

        <Transmitter
          value={FIC_10601}
          x={650}
          y={330}
          unit="BOE/M"
          max={170}
          HH={155}
          H={110}
          L={1}
          LL={0.1}
          c="lime"
          description="FLOWRATE OF OIL AND GAS FLUID FROM NK-1, NK-2 AND NK-3 WELLHEADS TO TEST SEPARATOR"
          tag="FIC_10601"
        />

        <Transmitter4
          value={PT_106011} x={240} y={112} c="transparent"
        />

        <Transmitter4
          value={PT_106012} x={240} y={162} c="transparent"
        />

        <Transmitter4
          value={PT_106013} x={240} y={182} c="transparent"
        />

        <Transmitter
          value={PT_10601}
          x={735}
          y={330}
          unit="MPa"
          max={15}
          HH={14}
          H={10}
          L={0.3}
          LL={0.033}
          c="lime"
          description="PRESSURE OF OIL AND GAS FLUID FROM NK-1, NK-2 AND NK-3 WELLHEADS TO TEST SEPARATOR"
          tag="PT-10601"
        />

        <Transmitter4
          value={TT_106011} x={240} y={112} c="transparent"
        />

        <Transmitter4
          value={TT_106012} x={240} y={162} c="transparent"
        />

        <Transmitter4
          value={TT_106013} x={240} y={182} c="transparent"
        />

        <Transmitter
          value={TT_10601}
          x={850}
          y={330}
          unit="°C"
          max={150}
          HH={145}
          H={140}
          L={25}
          LL={23}
          c="lime"
          description="TEMPERATURE OF OIL AND GAS FLUID FROM NK-1, NK-2 AND NK-3 WELLHEADS TO TEST SEPARATOR"
          tag="TT-10601"
        />

        <Transmitter4
          value={MPFT_106011} x={900} y={112} c="transparent"
        />

        <Transmitter4
          value={MPFT_106012} x={900} y={162} c="transparent"
        />

        <Transmitter4
          value={MPFT_106013} x={900} y={182} c="transparent"
        />

        <Transmitter
          value={MPFT_10601}
          x={1070}
          y={112}
          unit="BPM"
          max={100}
          HH={85}
          H={80}
          L={1}
          LL={0.1}
          c="lime"
          description="FLOWRATE OF CRUDE FROM NK-1, NK-2 AND NK-3 WELLHEADS TES SEPARATOR"
          tag="MPFT-10601"
        />

        <Transmitter4
          value={MPFT_106021} x={910} y={112} c="transparent"
        />

        <Transmitter4
          value={MPFT_106022} x={910} y={162} c="transparent"
        />

        <Transmitter4
          value={MPFT_106023} x={910} y={182} c="transparent"
        />

        <Transmitter
          value={MPFT_10602}
          x={1070}
          y={122}
          unit="SCF/S"
          max={100}
          HH={85}
          H={80}
          L={1}
          LL={0.1}
          c="lime"
          description="FLOWRATE OF CRUDE FROM NK-1, NK-2 AND NK-3 WELLHEADS TES SEPARATOR"
          tag="MPFT-10602"
        />

        <Transmitter4
          value={MPFT_106031} x={920} y={112} c="transparent"
        />

        <Transmitter4
          value={MPFT_106032} x={920} y={162} c="transparent"
        />

        <Transmitter4
          value={MPFT_106033} x={920} y={182} c="transparent"
        />

         <Transmitter
          value={MPFT_10603}
          x={1070}
          y={132}
          unit="LPM"
          max={50}
          HH={45}
          H={30}
          L={1}
          LL={0.1}
          c="lime"
          description="FLOWRATE OF CRUDE FROM NK-1, NK-2 AND NK-3 WELLHEADS TES SEPARATOR"
          tag="MPFT-10603"
        />

        <Transmitter
          value={fic10605}
          x={927}
          y={440}
          unit="BOE/M"
          max={70}
          HH={55}
          H={50}
          L={1}
          LL={0.1}
          c="lime"
          description="FLOWRATE OF OIL AND GAS FLUID TO CLOSE DRAIN FROM TEST HEADER"
          tag="FIC-10605"
        />

        



    </div>
  );
}

export default TestHeader;